import type { RouteRecordRaw } from 'vue-router'

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings/studio',
    name: 'settings-studio',
    component: () => import('./views/StudioSettingsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/settings/branding',
    name: 'settings-branding',
    component: () => import('./views/SettingsBrandingView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/settings/billing',
    name: 'settings-billing',
    component: () => import('./views/BillingView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], skipOnboardingCheck: true },
  },
  {
    path: '/settings/billing/plans',
    name: 'settings-billing-plans',
    component: () => import('./views/PlanCatalogView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], skipOnboardingCheck: true },
  },
]
